<template>
  <!-- Begin Page Content -->
  <div class="container" v-if="parent && type">
    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Selbeg.MN</h1>
      <div>
        <h4>{{parent.name}}/{{type.name}}</h4>
      </div>
    </div>

        <hr/>
    <div class="row">
      <div class="col col-12">
        <button class="btn btn-sm btn-block btn-secondary" @click="showFilter=!showFilter">Шүүлтүүр</button>
      </div>
      
    </div>
    <div  v-if="showFilter==true"  class=" my-4 border border-primary rounded">
      <div class="p-3">
        <div class="my-4 row">
          <div class="h4 col col-expand">{{parent.name}} / {{type.name}}</div>
          <div class="col col-auto">
            <button class="btn  btn-outline-secondary btn-sm mr-2" @click="resetFilter">Арилгах</button>
            <button class="btn btn-success btn-sm" @click="filterItems">Хайх</button>
          </div>
        </div>
        <hr/>
        <div>
        <div class="row">
          <div class="col col-expand"><h5>Машин сонгох</h5></div>
          <div class="col col-auto"><button class="btn btn-success btn-sm" @click="reset">Шинэчлэх</button></div>
        </div>
        <hr/>
        
        <div class="row">
            <div class="col col-md-6" >
              <div class="form-group">
                <label for="exampleFormControlSelect1">Үйлдвэрлэгч</label>
                <select class="form-control" v-model="selectedType">
                  <option v-for="type in cartypes" v-bind:value="type.id">{{type.name}}</option>
                </select>
              </div>
            </div>
            <div class="col col-md-6" >
              <div class="form-group">
                <label for="exampleFormControlSelect1">Марк</label>
                <select class="form-control" v-model="selectedMark">
                  <option v-for="mark in carmarks" v-bind:value="mark.id">{{mark.name}}</option>
                </select>
              </div>
            </div>
            <div class="col col-md-6">
              <div class="form-group">
                <label for="exampleFormControlSelect1">Арал</label>
                <select class="form-control" v-model="selectedAral">
                  <option v-for="aral in cararal" v-bind:value="aral.id">{{aral.name}}</option>
                </select>
              </div>
            </div>
            <div class="col col-md-6">
              <div class="form-group">
                <label for="exampleFormControlSelect1">Үндсэн он /Доод он/</label>
                <select class="form-control" v-model="selectedYear">
                  <option v-for="year in caryears" v-bind:value="year">{{year.name}}</option>
                </select>
              </div>
            </div>
            <div class="col col-md-6" v-if="selectedYear">
              <div class="form-group">
                <label for="exampleFormControlSelect1">Дээд он</label>
                <select class="form-control" v-model="selectedMaxYear">
                  <option v-for="year in caryears" v-bind:value="year">{{year.name}}</option>
                </select>
              </div>
            </div>
            <!-- <div class="col col-md-6">
              <div class="form-group">
                <label for="exampleFormControlSelect1">Модел</label>
                <select class="form-control" v-model="selectedModel">
                  <option v-for="model in carmodels" v-bind:value="model">{{model}}</option>
                </select>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <hr/>
      <div class="row p-3">
        <div class="col-md-3 col-sm-12 my-3">
          Төлөв
          <div class="custom-control custom-radio">
            <input type="radio" id="customRadio1" name="customRadio" class="custom-control-input" :value="true" v-model="isnew">
            <label class="custom-control-label" for="customRadio1">Шинэ</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="customRadio2" name="customRadio" class="custom-control-input" :value="false" v-model="isnew">
            <label class="custom-control-label" for="customRadio2">Хуучин</label>
          </div>
        </div>

        <div class="col-md-3 col-sm-12 my-3">
          Суурилуулалт
          <div class="custom-control custom-radio">
            <input type="radio" id="mountRadio" name="mountRadio" class="custom-control-input" :value="true" v-model="mount">
            <label class="custom-control-label" for="mountRadio">Тийм</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="mountRadio2" name="mountRadio2" class="custom-control-input" :value="false" v-model="mount">
            <label class="custom-control-label" for="mountRadio2">Үгүй</label>
          </div>
        </div>
        <div class="col-md-3 col-sm-12 my-3">
          Хүргэлт
          <div class="custom-control custom-radio">
            <input type="radio" id="shippingRadio" name="shippingRadio" class="custom-control-input" :value="true" v-model="shipping">
            <label class="custom-control-label" for="shippingRadio">Тийм</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="shippingRadio2" name="shippingRadio2" class="custom-control-input" :value="false" v-model="shipping">
            <label class="custom-control-label" for="shippingRadio2">Үгүй</label>
          </div>
        </div>
        <div class="col-md-3 col-sm-12 my-3" v-if="type.side!=null && type.side!=undefined && type.side!=null && type.side==true">
          Байрлал
          <div class="custom-control custom-radio">
            <input type="radio" id="sideRadio" name="sideRadio" class="custom-control-input" :value="'right'" v-model="side">
            <label class="custom-control-label" for="sideRadio">Баруун</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="sideRadio2" name="sideRadio2" class="custom-control-input" :value="'left'" v-model="side">
            <label class="custom-control-label" for="sideRadio2">Зүүн</label>
          </div>
        </div>
        <div class="col-md-3 col-sm-12 my-3" v-if="type.vside!=null && type.vside!=undefined && type.vside!=null && type.vside==true">
          Байрлал
          <div class="custom-control custom-radio">
            <input type="radio" id="vsideRadio" name="vsideRadio" class="custom-control-input" :value="'front'" v-model="vside">
            <label class="custom-control-label" for="vsideRadio">Урд</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="vsideRadio2" name="vsideRadio2" class="custom-control-input" :value="'back'" v-model="vside">
            <label class="custom-control-label" for="vsideRadio2">Хойд</label>
          </div>
        </div>
        <div class="col-md-3 col-sm-12 my-3" >
          Эрэмбэлэх
          <div class="custom-control custom-radio">
            <input type="radio" id="sortRadio" name="sortRadio" class="custom-control-input" :value="'date,desc'" v-model="sortby">
            <label class="custom-control-label" for="sortRadio">Сүүлд нэмсэнээр</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="sortRadio2" name="sortRadio2" class="custom-control-input" :value="'price,desc'" v-model="sortby">
            <label class="custom-control-label" for="sortRadio2">Үнэтэй нь эхэндээ</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="sortRadio3" name="sortRadio3" class="custom-control-input" :value="'price,asc'" v-model="sortby">
            <label class="custom-control-label" for="sortRadio3">Хямд нь эхэндээ</label>
          </div>
        </div>
      </div>
  
      

    </div>
    <hr/>
    
    <div class="row justify-content-center">
      <div class="col col-md-3 col-sm-6 my-3"  >
        <div class="card" style="cursor:pointer;" v-bind:class="[selectedCategory==null ? 'bg-success text-white':'']" @click="getCategoryItems(null)">
          <div class="card-body">
            <p class="card-text">{{type.name}} /Бүгд/</p>
          </div>
        </div>
      </div>
      <div class="col col-md-3 col-sm-6 my-3"  v-for="category in categories">
        <div class="card" style="cursor:pointer;" v-bind:class="[selectedCategory && selectedCategory==category.id ? 'bg-success text-white':'']" @click="getCategoryItems(category.id)">
          <div class="card-body">
            <p class="card-text">{{category.name}} /{{category.numberOfItems}}/</p>
          </div>
        </div>
      </div>
    </div>
    <hr/>

    <!-- fb fetch -->
    <div v-if="searched==false">

      <div class="row my-5">
        <div class="col col-12 my-3" v-for="(item, index) in items">
          <div class="card">
            <div class="card-body">
              <p  class="font-weight-bold text-dark text-lg" v-if="item.shortCategory">
                <span v-if="item.shortCategory.category">{{item.shortCategory.category}}</span>
                <span v-if="item.shortCategory.type">/{{item.shortCategory.type}}</span>
                <span v-if="item.shortCategory.subtype">/{{item.shortCategory.subtype}}</span>

              </p>
              <div class="d-flex ">
                <img style="border-radius:5%;height:160px;" v-if="_getImage(item)" :src="_getImage(item)" alt="">
                <div class="mx-3  flex-fill ">
                  <p class="font-weight-bold">{{index+1}}. {{item.name}}</p>

                  <p  class="" v-if="item.shortCarType">
                    <span v-if="item.shortCarType.cartype">{{item.shortCarType.cartype}}</span>
                    <span v-if="item.shortCarType.carmark">/{{item.shortCarType.carmark}}</span>
                    <span v-if="item.shortCarType.aral">/{{item.shortCarType.aral}}</span>
                    <span v-if="item.shortCarType.caryear">/{{item.shortCarType.caryear}}</span>
                    <span v-if="item.shortCarType.carmodel">/{{item.shortCarType.carmodel}}</span>

                  </p>
                  <div class="row  justify-content-between">
                    <div class="col col-md-6 col-sm-12">
                      <div v-if="item.storeData">
                        <span  class="text-primary font-weight-bold"  v-if="item.storeData.name">{{item.storeData.name}}</span>
                        <br/>
                        <p  class="" v-if="item.storeData.shortAddress">
                          <span v-if="item.storeData.shortAddress.city">{{item.storeData.shortAddress.city}}</span>
                          <span v-if="item.storeData.shortAddress.district">/{{item.storeData.shortAddress.district}}</span>
                          <span v-if="item.storeData.shortAddress.horoo">/{{item.storeData.shortAddress.horoo}}</span>
                          <span v-if="item.storeData.address">/{{item.storeData.address}}</span>

                        </p>
                        
                        
                      </div>
                    </div>
                    <div  class="col col-md-6 col-sm-12">
                      <div  style="text-align:end">
                        <span class="badge badge-success" v-if="item.mount==true">Суурилуулалттай</span>
                        <span  class="badge badge-danger" v-else>Суурилуулалтгүй</span>
                      </div>
                      <div  style="text-align:end">
                        <span class="badge badge-success" v-if="item.shipping==true">Хүргэлттэй</span>
                        <span  class="badge badge-danger" v-else>Хүргэлтгүй</span>
                      </div>
                    </div>
                    
                  </div>
                </div>

              </div>
              
            </div>
          </div>
        </div>
        <div class="col" v-if="end!=true">
          <button @click.prevent="getItems" class="btn btn-success btn-sm btn-block">Цааш нь үзэх</button>
        </div>
      </div>
    </div>
    
    <!-- Filter -->
    <div v-if="searched==true">
      <div class="text-center text-primary text-lg">
        <p v-if="filterCount">Нийт хайлтаар илэрсэн {{filterCount}} сэлбэг</p>
        <p v-else>Хайлтанд тохирох сэлбэг олдсонгүй.</p>
      </div>

      <div class="row my-5">
        <div class="col col-12 my-3" v-for="(item, index) in filteredItems">
          <div class="card">
            <div class="card-body">
              <p  class="font-weight-bold text-dark text-lg" v-if="item">
                <span v-if="item.category">{{item.category}}</span>
                <span v-if="item.type">/{{item.type}}</span>
                <span v-if="item.subtype">/{{item.subtype}}</span>

              </p>
              <div class="d-flex ">
                <img style="border-radius:5%;height:160px;" v-if="_getFilterImage(item)" :src="_getFilterImage(item)" alt="">
                <div class="mx-3  flex-fill ">
                  <p class="font-weight-bold">{{index+1}}. {{item.name}}</p>

                  <p  class="" v-if="item">
                    <span v-if="item.cartype">{{item.cartype}}</span>
                    <span v-if="item.carmark">/{{item.carmark}}</span>
                    <span v-if="item.aral">/{{item.aral}}</span>
                    <span v-if="item.caryear">/{{item.caryear}}</span>
                    <span v-if="item.carmodel">/{{item.carmodel}}</span>

                  </p>
                  <div class="row  justify-content-between">
                    <div class="col col-md-6 col-sm-12">
                      <div v-if="item">
                        <span  class="text-primary font-weight-bold"  v-if="item.ownerName">{{item.ownerName}}</span>
                        <br/>
                        <p  class="" v-if="item.shortAddress">
                          <span v-if="item.shortAddress">{{item.shortAddress}}</span>

                        </p>
                        
                        
                      </div>
                    </div>
                    <div  class="col col-md-6 col-sm-12">
                      <div  style="text-align:end">
                        <span class="badge badge-success" v-if="item.mount==true">Суурилуулалттай</span>
                        <span  class="badge badge-danger" v-else>Суурилуулалтгүй</span>
                      </div>
                      <div  style="text-align:end">
                        <span class="badge badge-success" v-if="item.shipping==true">Хүргэлттэй</span>
                        <span  class="badge badge-danger" v-else>Хүргэлтгүй</span>
                      </div>
                    </div>
                    
                  </div>
                </div>

              </div>
              
            </div>
          </div>
        </div>
        <div class="col" v-if="filterend!=true">
          <button @click.prevent="filterNextPage()" class="btn btn-success btn-sm btn-block">Цааш нь үзэх...</button>
        </div>
      </div>
    </div>


  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require('../../firebaseConfig.js');
import Vue from 'vue';
import { mapState } from 'vuex';
import axios from 'axios';
export default {
  name: "SubCategoryItems",
  data() {
    return {
      parent:null,
      type:null,
      categories:[],
      items:[],
      firstVisible:null,
      lastVisible:null,
      end:false,
      selectedCategory:null,
      categorycounts:[],
      isnew:null,
      mount:null,
      shipping:null,
      side:null,
      vside:null,
      colors:[],
      sortby:null,
      showFilter:false,
      cartypes:[],
      carmarks:[],
      cararal:[],
      caryears:[],
      carmodels:[],
      selectedType:null,
      selectedMark:null,
      selectedAral:null,
      selectedYear:null,
      selectedMaxYear:null,
      selectedModel:null,
      showFilter:false,
      spage:0,
      spagesize:20,
      searched:false,
      filteredItems:[],
      filterend:false, 
      filterText:null,
      filterCount:null
    };
  },
  watch: {
    selectedType: function (val) {
      this.carmarks=[];
      this.cararal=[];
      this.caryears=[];
      this.carmodels=[];
      this.selectedMark=null;
      this.selectedAral=null;
      this.selectedYear=null;
      this.selectedMaxYear=null;
      this.selectedModel=null;
      if(val && val!=''){
        fb.db.collection("cartypes").doc(val).collection("marks").orderBy("name").get().then(docs=>{
          if(docs && !docs.empty){
            this.carmarks=[];
            docs.docs.forEach(value=>{
              if(value && value.exists){
                let item=value.data();
                item.id=value.id;
                this.carmarks.push(item);
              }
            });
          }
        });
      }
    },
    selectedMark: function (val) {

      this.cararal=[];
      this.caryears=[];
      this.carmodels=[];
      this.selectedAral=null;
      this.selectedYear=null;
      this.selectedMaxYear=null;
      this.selectedModel=null;
      if(val && val!=''){
        fb.db.collection("cartypes").doc(this.selectedType).collection("marks").doc(val).collection("araluud").orderBy("createdAt").get().then(docs=>{
          if(docs && !docs.empty){
            this.cararal=[];
            docs.docs.forEach(value=>{
              if(value && value.exists){
                let item=value.data();
                item.id=value.id;
                this.cararal.push(item);
              }
            });
          }
        });
      }
    },
    selectedAral: function (val) {

      this.caryears=[];
      this.carmodels=[];
      this.selectedYear=null;
      this.selectedMaxYear=null;
      this.selectedModel=null;
      if(val && val!=''){
        fb.db.collection("cartypes").doc(this.selectedType).collection("marks").doc(this.selectedMark).collection("araluud").doc(val).get().then(doc=>{

          if(doc && doc.exists && doc.data() && doc.data().years && doc.data().years.length>0){
            this.caryears=[];
            for(const yearRef of doc.data().years){
              yearRef.get().then(yearDoc=>{
                if(yearDoc && yearDoc.exists){
                  let item=yearDoc.data();
                  item.id=yearDoc.id;
                  this.caryears.push(item);
                  this.caryears.sort(function(a,b){
                      return a.name.localeCompare(b.name);
                  });
                }
              });
            }

          }
          else{

          }
        });
        
      }
    },
    selectedYear: function (val) {

      // this.carmodels=[];
      // this.selectedModel=null;
      // if(val && val.id){
      //   fb.db.collection("cartypes").doc(this.selectedType).collection("marks").doc(this.selectedMark).collection("years").doc(val.id).get().then(doc=>{
      //     if(doc && doc.exists && doc.data() && doc.data().enginePowers && doc.data().enginePowers.length>0){
      //       this.carmodels=[];
      //       this.carmodels=doc.data().enginePowers;
      //     }
      //   });
      // }
    },

  },
  methods: {
    getCategories(){
      if(this.categoryId && this.typeId){
        fb.db.collection("cartypes").orderBy("name").get().then(docs=>{
          if(docs && !docs.empty){
            this.cartypes=[];
            docs.docs.forEach(value=>{
              if(value && value.exists){
                let item=value.data();
                item.id=value.id;
                this.cartypes.push(item);
              }
            });
            // this.getCategoryItems();
          }
        });
        fb.db.collection("selbegtypes").doc(this.categoryId).get().then(value=>{
    
          if(value && value.exists){
            let item=value.data();
            item.id=value.id;
            this.parent=item;

            value.ref.collection("children").doc(this.typeId).get().then(gg=>{
    
              if(gg && gg.exists){
                let item1=gg.data();
                item1.id=gg.id;
                this.type=item1;

                this.getItems();
              }

            });

          }
        });
        fb.db.collection("selbegtypes").doc(this.categoryId).collection("children").doc(this.typeId).collection("children").orderBy("createdAt").get().then(docs=>{
          if(docs && !docs.empty){
            this.categories=[];
            docs.docs.forEach(value=>{
              if(value && value.exists){
                let item=value.data();
                item.id=value.id;
                this.categories.push(item);
              }
            });
          }
        });
      }
    },
    async getItems(){
      if(this.parent && this.parent.id && this.type && this.type.id){

        if(this.end!=true){
          var querySnapshot;
          var first=false;
          if(this.lastVisible==null){
            var query=fb.db.collectionGroup("selbeg")
              .where("category", "==", fb.db.collection("selbegtypes").doc(this.categoryId))
              .where("type", "==", fb.db.collection("selbegtypes").doc(this.categoryId).collection("children").doc(this.typeId));

            if(this.selectedCategory!=undefined && this.selectedCategory!=null){
              query=query.where("subtype", "==", fb.db.collection("selbegtypes").doc(this.categoryId).collection("children").doc(this.typeId).collection('children').doc(this.selectedCategory));
            }

            query=query.where("active", "==", true).orderBy("createdAt", "desc").limit(30);

            querySnapshot=await 
              query.get();
            if(querySnapshot!=null && !querySnapshot.empty){
              this.firstVisible=querySnapshot.docs[0];
              first=true;
            }
          }
          else{
            var query=fb.db.collectionGroup("selbeg")
              .where("category", "==", fb.db.collection("selbegtypes").doc(this.categoryId))
              .where("type", "==", fb.db.collection("selbegtypes").doc(this.categoryId).collection("children").doc(this.typeId));
            if(this.selectedCategory!=undefined && this.selectedCategory!=null){
              query=query.where("subtype", "==", fb.db.collection("selbegtypes").doc(this.categoryId).collection("children").doc(this.typeId).collection('children').doc(this.selectedCategory));
            }
            query=query.where("active", "==", true).orderBy("createdAt", "desc")
              .startAfter(this.lastVisible)
              .limit(30);

            querySnapshot=await
              query.get();
          }
          
          if(querySnapshot!=null && !querySnapshot.empty){

            if(first==true || ( first!=null && this.firstVisible.id!=null && this.firstVisible.id!=querySnapshot.docs[0].id)){
              // console.log("abc");
              for(const itemDoc of querySnapshot.docs){
                let item=itemDoc.data();
                item.id=itemDoc.id;
                item.storeData=null;
                if(item.store){
                  item.store.get().then(storeDoc=>{
                    if(storeDoc && storeDoc.exists){
                      item.storeData=storeDoc.data();
                    }
                  })
                }
                // console.log(item);
                this.items.push(item);
              }
              this.lastVisible=querySnapshot.docs[querySnapshot.docs.length-1];
            }
            else
              this.end=true;
            
          }
        }
      }
    },
    getCategoryItems(categoryId){
      this.resetFilter();
      this.showFilter=false;
      this.items=[];
      this.selectedCategory=categoryId;
      this.firstVisible=null;
      this.lastVisible=null;
      this.end=false;
      this.getItems();
    },
    filterItems(){
        this.searched=true;
        this.filteredItems=[];
        this.spage=0;
        this.filterCount=null;
        this.filterend=false;
        this.getFilterItems();
      
    },
    filterNextPage(){
      if(this.filterend!=true){
        this.searched=true;
        this.spage++;
        this.getFilterItems();
      }
    },
    async getFilterItems(){
      var tmp={};
      tmp['page']=this.spage;
      tmp['size']=this.spagesize;
      tmp['typeId']=this.typeId;
      if(this.selectedCategory){
        tmp['subtypeId']=this.selectedCategory;
      }

      if(this.sortby && this.sortby!=''){
        tmp['sort']=this.sortby;
      }
      if(this.isnew!=null && this.isnew!=undefined){
        tmp['isNew']=this.isnew;
      }
      if(this.mount!=null){
        tmp['mount']=this.mount;
      }
      if(this.shipping!=null){
        tmp['shipping']=this.shipping;
      }
      // if(colors!=null && colors.length>0){
      //   tmp['colorId']=colors;
      // }
      if(this.side!=null && this.side!=''){
        tmp['side']=this.side;
      }
      if(this.vside!=null && this.vside!=''){
        tmp['vside']=this.vside;
      }

      if(this.selectedType)
        tmp['cartypeId']=this.selectedType;
      if(this.selectedMark)
        tmp['carmarkId']=this.selectedMark;
      if(this.selectedYear)
        tmp['caryearId']=this.selectedYear.id;
      if(this.selectedAral)
        tmp['cararalId']=this.selectedAral;
        console.log(fb.searchUrl)
      axios.get(fb.searchUrl+"/filter", {
        params: tmp
      }).then(response=>{
        this.searched=true;
        // console.log(response);
        if(response && response.data && response.data.content && response.data.content.length>0){
          if(response.data.totalElements){
            this.filterCount=response.data.totalElements;
          }
          for(const object of response.data.content){
            this.filteredItems.push(object);
          }
          if(response.data.last==true)
            this.filterend=true;
        }
      })
    },
    resetFilter(){
      this.filterText=null;
      this.filterend=false;
      this.filteredItems=[];
      this.searched=false;
      this.spage=0;
      this.isnew=null;
      this.mount=null;
      this.shipping=null;
      this.side=null;
      this.vside=null;
      this.colors=[];
      this.sortby=null;
    },

    _getImage(obj) {
      if (obj.images != null && obj.images != undefined && obj.images.length>0) {

        return obj.images[0]["fileUrl"];
      }
      return null;
    },
    _getFilterImage(obj){
    
      if (obj.imageUrl) {

        return obj.imageUrl;
      }
      return null;
    },
    reset(){
      this.carmarks=[];
      this.cararal=[];
      this.caryears=[];
      this.carmodels=[];
      this.selectedType=null;
      this.selectedMark=null;
      this.selectedAral=null;
      this.selectedYear=null;
      this.selectedMaxYear=null;
      this.selectedModel=null;
      this.items=[];
      this.firstVisible=null;
      this.lastVisible=null;
      this.end=false;
    },
  },
  props:{
    categoryId: {
      required: true
    },
    typeId: {
      required: true
    }
  },
  created(){
    this.getCategories();
  }
};
</script>

